<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  [loading]="loading()"
  [title]="policy.name | i18n"
  subtitle=""
>
  <span bitBadge [variant]="policyEnabled() ? 'success' : 'secondary'" bitDialogHeaderEnd>{{
    (policyEnabled() ? "on" : "off") | i18n
  }}</span>
  <ng-container bitDialogContent>
    @if (loading()) {
      <bit-spinner></bit-spinner>
    } @else {
      @if (policy.prerequisiteKey) {
        <bit-callout type="info" [title]="'prerequisite' | i18n">
          {{ policy.prerequisiteKey | i18n }}
          @if (policy.prerequisiteLinkHref && policy.prerequisiteLinkTextKey) {
            <a bitLink [href]="policy.prerequisiteLinkHref" target="_blank" rel="noreferrer">
              {{ policy.prerequisiteLinkTextKey | i18n }}
            </a>
          }
        </bit-callout>
      }
      @if (policy.warningKey) {
        <bit-callout type="warning">{{ policy.warningKey | i18n }}</bit-callout>
      }
      @if (policy.showDescription) {
        <p bitTypography="body1">{{ policy.description | i18n }}</p>
      }
      <ng-template #policyForm></ng-template>
    }
  </ng-container>
  <ng-container bitDialogFooter>
    <button bitButton buttonType="primary" [disabled]="saveDisabled()" bitFormButton type="submit">
      {{ "save" | i18n }}
    </button>
  </ng-container>
</form>
